// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CraftEditor_craftEditorContainer__MScDC {
  margin: 0 auto;
  width: 100%;
  height: 100%;
}

.CraftEditor_gridWrapper__h-x39 {
  display: flex;
  flex-direction: row;
  width: 100%;
  flex: 2 1;
}

.CraftEditor_column__bRCjK {
  padding: 0 !important;
  width: calc(100vw - 450px) !important;
  height: calc(100vh - 80px) !important;
  overflow: hidden;
  overflow-y: scroll !important;
}

.CraftEditor_columnStepper__Jcdq8 {
  padding: 0 !important;
  width: calc(100vw - 450px) !important;
  height: calc(100vh - 13.7rem) !important;
  overflow: hidden;
  overflow-y: scroll !important;
}

.CraftEditor_tab__CrXbk {
  width: 450px !important;
  padding: 0px 5px 10px 5px;
  height: calc(100vh - 90px) !important;
  position: relative;
  overflow: hidden;
}

.CraftEditor_tabStepper__pH0Sf {
  width: 450px !important;
  padding: 0px 5px 10px 5px;
  height: calc(100vh - 14.4rem) !important;
  position: relative;
  overflow: hidden;
}

.CraftEditor_columnCustomEmail__4InYZ {
  height: 100vh !important;
}

.CraftEditor_tabCustomEmail__Hhsx7 {
  height: calc(100vh - 47px) !important;
}

.CraftEditor_segment__cgJS6 {
  max-height: 20rem !important;
  overflow-y: auto !important;
}

.CraftEditor_pageIndicator__JzRwi {
  display: flex;
  position: absolute;
  height: 30px;
  margin-top: -29px;
  font-size: 12px;
  color: #fff;
  line-height: 15px;
  background-color: #2680eb;
  padding: 0.5rem;
  z-index: 9999;
}

.CraftEditor_pageIndicator__JzRwi:before {
  content: " ";
  height: 0;
  position: absolute;
  width: 0;
  right: 18px;
  border: 8px solid transparent;
  border-right-color: #2680eb;
}

.CraftEditor_undoRedoContainer__5aQfq {
  position: absolute;
  top: 41px;
  z-index: 101;
  padding-left: 5px;
}

.CraftEditor_undoRedoContainerCustomEmail__3nl5x {
  position: absolute;
  top: 0px;
  z-index: 101;
  padding-left: 5px;
}

.CraftEditor_undoRedoContainerCreate__EaDNl {
  position: absolute;
  top: 120px;
  z-index: 101;
  padding-left: 5px;
}

@media only screen and (min-width: 1200px) {
  .CraftEditor_segment__cgJS6 {
    max-height: 26rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/TemplateEditor/components/CraftEditor.module.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,WAAA;EACA,YAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,SAAA;AACF;;AAEA;EACE,qBAAA;EACA,qCAAA;EACA,qCAAA;EACA,gBAAA;EACA,6BAAA;AACF;;AAEA;EACE,qBAAA;EACA,qCAAA;EACA,wCAAA;EACA,gBAAA;EACA,6BAAA;AACF;;AACA;EACE,uBAAA;EACA,yBAAA;EACA,qCAAA;EACA,kBAAA;EACA,gBAAA;AAEF;;AACA;EACE,uBAAA;EACA,yBAAA;EACA,wCAAA;EACA,kBAAA;EACA,gBAAA;AAEF;;AACA;EACE,wBAAA;AAEF;;AAAA;EACE,qCAAA;AAGF;;AAAA;EACE,4BAAA;EACA,2BAAA;AAGF;;AAAA;EACE,aAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,WAAA;EACA,iBAAA;EACA,yBAAA;EACA,eAAA;EACA,aAAA;AAGF;;AAAA;EACE,YAAA;EACA,SAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;EACA,6BAAA;EACA,2BAAA;AAGF;;AAAA;EACE,kBAAA;EACA,SAAA;EACA,YAAA;EACA,iBAAA;AAGF;;AADA;EACE,kBAAA;EACA,QAAA;EACA,YAAA;EACA,iBAAA;AAIF;;AAFA;EACE,kBAAA;EACA,UAAA;EACA,YAAA;EACA,iBAAA;AAKF;;AAFA;EACE;IACE,iBAAA;EAKF;AACF","sourcesContent":[".craftEditorContainer {\n  margin: 0 auto;\n  width: 100%;\n  height: 100%;\n}\n\n.gridWrapper {\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  flex: 2;\n}\n\n.column {\n  padding: 0 !important;\n  width: calc(100vw - 450px) !important;\n  height: calc(100vh - 80px) !important;\n  overflow: hidden;\n  overflow-y: scroll !important;\n}\n\n.columnStepper {\n  padding: 0 !important;\n  width: calc(100vw - 450px) !important;\n  height: calc(100vh - 13.7rem) !important;\n  overflow: hidden;\n  overflow-y: scroll !important;\n}\n.tab {\n  width: 450px !important;\n  padding: 0px 5px 10px 5px;\n  height: calc(100vh - 90px) !important;\n  position: relative;\n  overflow: hidden;\n}\n\n.tabStepper {\n  width: 450px !important;\n  padding: 0px 5px 10px 5px;\n  height: calc(100vh - 14.4rem) !important;\n  position: relative;\n  overflow: hidden;\n}\n\n.columnCustomEmail {\n  height: 100vh !important;\n}\n.tabCustomEmail {\n  height: calc(100vh - 47px) !important;\n}\n\n.segment {\n  max-height: 20rem !important;\n  overflow-y: auto !important;\n}\n\n.pageIndicator {\n  display: flex;\n  position: absolute;\n  height: 30px;\n  margin-top: -29px;\n  font-size: 12px;\n  color: #fff;\n  line-height: 15px;\n  background-color: #2680eb;\n  padding: 0.5rem;\n  z-index: 9999;\n}\n\n.pageIndicator:before {\n  content: ' ';\n  height: 0;\n  position: absolute;\n  width: 0;\n  right: 18px;\n  border: 8px solid transparent;\n  border-right-color: #2680eb;\n}\n\n.undoRedoContainer {\n  position: absolute;\n  top: 41px;\n  z-index: 101;\n  padding-left: 5px;\n}\n.undoRedoContainerCustomEmail {\n  position: absolute;\n  top: 0px;\n  z-index: 101;\n  padding-left: 5px;\n}\n.undoRedoContainerCreate {\n  position: absolute;\n  top: 120px;\n  z-index: 101;\n  padding-left: 5px;\n}\n\n@media only screen and (min-width: 1200px) {\n  .segment {\n    max-height: 26rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"craftEditorContainer": `CraftEditor_craftEditorContainer__MScDC`,
	"gridWrapper": `CraftEditor_gridWrapper__h-x39`,
	"column": `CraftEditor_column__bRCjK`,
	"columnStepper": `CraftEditor_columnStepper__Jcdq8`,
	"tab": `CraftEditor_tab__CrXbk`,
	"tabStepper": `CraftEditor_tabStepper__pH0Sf`,
	"columnCustomEmail": `CraftEditor_columnCustomEmail__4InYZ`,
	"tabCustomEmail": `CraftEditor_tabCustomEmail__Hhsx7`,
	"segment": `CraftEditor_segment__cgJS6`,
	"pageIndicator": `CraftEditor_pageIndicator__JzRwi`,
	"undoRedoContainer": `CraftEditor_undoRedoContainer__5aQfq`,
	"undoRedoContainerCustomEmail": `CraftEditor_undoRedoContainerCustomEmail__3nl5x`,
	"undoRedoContainerCreate": `CraftEditor_undoRedoContainerCreate__EaDNl`
};
export default ___CSS_LOADER_EXPORT___;
